<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Map.scss";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

 .alert-float{
    left: -3px;
    position: absolute;
    top:-1px;
  }

  .container-symbology{
    padding: 10px;
    width: auto;
  }

  .vs-radio--borde{
    border: 2px solid #FFFF!important;
  }

  .device-info>.shadow-drop{
    padding-top: 0.5rem!important;
    padding-bottom: 0.5rem!important;
  }

  .cursor-ponter:hover{
    cursor: pointer;
  }

  .container-circuits{
    max-height: 150px;
    overflow-y: auto;
  }

  .container-alerts-control{
    display: grid;
    gap: 5px;
    grid-template-columns: repeat( 4, minmax(100px, 1fr) );
    grid-template-rows: auto;
    justify-content: space-evenly;
  }

  .vs-radio--borde{
    border: 2px solid #626262 !important;
  }

  .container-tags{
    max-height: 100px;
    max-width: calc(100% - 60px);
    overflow-y: auto;
  }

  .con-vs-slider{
    min-width: 50px!important;
    width:100px!important;
  }

  .leaflet-topcenter {
    position: absolute;
    top: 0px;
    left: 183px;
    width: calc(100% - 183px)
  }

  .container-schedules{
    max-height: 150px;
    overflow-y: auto;
    padding-bottom: 16px;
  }

  .container-schedule{
    border-bottom: 2px solid #f0f0f0;
  }

</style>
<template>
  <div class="item-grid-view vx-row match-height mt-4">
    <div class="vx-col w-full">
      <vx-card class="grid-view-item mb-base overflow-hidden">
        <div id="container-map" v-if="status_mapa">
            <l-map style="height: 100%; overflow: hidden;" :zoom="17" :center="center" ref="mymap">
                <l-control position="bottomleft">
                  <div class="relative">
                    <div class="container-symbology bg-white border-2 border-solid border-grey text-center rounded-lg mt-3 centerx">
                        <div  v-if="(allSelected || circuitsSelected.length == circuits.length) && !selectMarkers">
                          <div class="w-5 h-5 inline-block rounded-sm align-middle"  :style="{ 'background-color': '#000000' }"  ></div>
                          <div class="inline-block align-middle ml-2">{{$t('Labels.All')}}</div>
                        </div>
                        <div class="container-circuits" v-if="!selectMarkers">
                          <div class="text-left my-1" v-for="(item) in circuits" v-bind:key="item.uuid" v-if="circuitsSelected.indexOf(item.uuid) !== -1 && !allSelected && circuitsSelected.length < circuits.length">
                            <div class="w-5 h-5 inline-block rounded-sm align-middle"  :style="{ 'background-color': item.color }"  ></div>
                            <div class="inline-block align-middle ml-2">{{item.name}}</div>
                          </div>
                        </div>
                        <vs-checkbox v-model="selectMarkers"  class="my-4"><span class="font-bold capitalize">{{$t('Labels.EnabledSelection')}}</span></vs-checkbox>
                        <div class="py-1 text-left" v-if="selectMarkers">
                          <div class="align-middle inline-block">{{$t('Labels.AssignToCircuit')}}</div>
                          <feather-icon v-if="!showAssignCircuit" icon="ChevronDownIcon" @click="showAssignCircuit = true"  svgClasses="h-5 w-5 text-grey-ligth ml-2 pt-1" class="float-right cursor-pointer align-middle inline-block "/>
                          <feather-icon v-else icon="ChevronUpIcon" @click="showAssignCircuit = false"  svgClasses="h-5 w-5 text-grey-ligth ml-2 pt-1" class="float-right cursor-pointer align-middle inline-block "/>
                        </div>
                        <div class="py-2" v-if="showAssignCircuit == true">
                          <v-select 
                            :options="circuits" 
                            :reduce="circuit => circuit.uuid" 
                            label="name" 
                            v-if="circuits.length > 0" 
                            v-model="circuitToAssign" 
                            v-on:input="requestPassword('assignSelected')"
                          >
                            <template #option="{name, color}">
                              <div>
                                <div class="w-5 h-5 inline-block rounded-sm align-middle" :style="{ 'background-color': color }"></div>
                                <div class="inline-block ml-2 align-middle">{{name}}</div>
                              </div>
                            </template>
                          </v-select>
                        </div>
                        <div class="py-1 text-left" v-if="selectMarkers">
                          <div class="align-middle inline-block">{{$t('Labels.ControlDimming')}}</div>
                          <feather-icon v-if="!showControlDimming" icon="ChevronDownIcon" @click="showControlDimming = true"  svgClasses="h-5 w-5 text-grey-ligth ml-2 pt-1" class="float-right cursor-pointer align-middle inline-block "/>
                          <feather-icon v-else icon="ChevronUpIcon" @click="showControlDimming = false"  svgClasses="h-5 w-5 text-grey-ligth ml-2 pt-1" class="float-right cursor-pointer align-middle inline-block "/>
                        </div>
                        <div class="p-2"  v-if="showControlDimming == true">
                          <div class="text-center my-2">
                            <div class="inline-block align-middle font-bold" >Fijo</div>
                            <div class="inline-block align-middle mx-2">
                              <vs-switch v-model="showControlDimmingSchedule" color="success"/>
                            </div>
                            <div class="inline-block align-middle font-bold">Por horarios</div>
                          </div>
                          <div v-if="!showControlDimmingSchedule">
                            <div class="w-full text-center">
                              <iconLight width="40" height="40" iconColor="#ffbd59" :level="slideLight" />
                            </div>
                            <div class="w-full my-2 text-center">
                              <div class="inline-block align-middle font-bold" :class="{'text-grey': controlLight }" >Off</div>
                              <div class="inline-block align-middle mx-2">
                                <vs-switch v-model="controlLight" color="success"/>
                              </div>
                              <div class="inline-block align-middle font-bold" :class="{'text-grey': !controlLight }">On</div>
                            </div>
                            <div class="w-full text-center my-4">
                              <vs-slider class="m-auto" v-model="slideLight" :min="0" :max="100" text-fixed="%"/>
                            </div>
                            <div class="w-full text-center">
                              <vs-button @click="requestPassword('dimming')" size="small" color="primary" class="">{{$t('Labels.Apply')}}</vs-button>
                            </div>
                          </div>
                          <div v-if="showControlDimmingSchedule" class="">
                            <div class="block h-16 p-2">
                              <vs-button color="primary" size="small" class="float-right" @click="addSchedule()">{{$t('Labels.Add')}}</vs-button>
                            </div>
                            <div class="container-schedules">
                              <div class="container-schedule" v-for="(item, index) in schedules" v-bind:key="index">
                                <div class="w-full sm:w-1/5 sm:inline-block sm:p-4">
                                  <div class="text-center mb-2">{{$t('Labels.StartDimming')}}</div>
                                  <div class="text-center">
                                    <iconLight width="40" height="40" iconColor="#ffbd59" :level="item.startDimming" />
                                  </div>
                                  <div>
                                    <vs-slider v-model="item.startDimming" :min="0" :max="100" text-fixed="%"/>
                                  </div>
                                </div>
                                <div class="w-full sm:w-1/5 sm:inline-block sm:p-4">
                                  <div class="text-center mb-2">{{$t('Labels.EndDimming')}}</div>
                                  <div class="text-center">
                                    <iconLight width="40" height="40" iconColor="#ffbd59" :level="item.endDimming" />
                                  </div>
                                  <div>
                                    <vs-slider v-model="item.endDimming" :min="0" :max="100" text-fixed="%"/>
                                  </div>
                                </div>
                                <div class="w-full sm:w-3/5 sm:inline-block sm:p-4 align-top">
                                  <div class="w-full sm:w-2/5 sm:inline-block sm:p-4 align-top">
                                    <div class="text-center mb-2">{{$t('Labels.StartTime')}}</div>
                                    <div class="text-center">
                                      <vue-timepicker format="HH:mm" v-model="item.startSchedule"></vue-timepicker>
                                    </div>
                                  </div>
                                  <div class="w-full sm:w-2/5 sm:inline-block sm:p-4 align-top">
                                    <div class="text-center mb-2">{{$t('Labels.EndTime')}}</div>
                                    <div class="text-center">
                                      <vue-timepicker format="HH:mm" v-model="item.endSchedule"></vue-timepicker>
                                    </div>
                                  </div>
                                  <div class="w-full sm:w-1/5 sm:inline-block text-center mt-10">
                                    <feather-icon @click="deleteSchedule(index)" icon="TrashIcon" svgClasses="h-6 w-6 text-danger" class="cursor-pointer hover:text-primary"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="text-right">
                              <vs-button @click="requestPassword('schedule')" size="small" color="primary" class="mr-2 mt-6">{{$t('Labels.Apply')}}</vs-button>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </l-control>
                <l-control position="bottomright">
                  <div class="container-symbology bg-white border-2 border-solid border-grey text-center rounded-lg mt-3 centerx">
                    <div class="text-center font-bold text-lg mt-2" v-if="!selectMarkers"><iconEnergy width="18" height="18" iconColor="#333"/> {{totalCurrent}} <span class="text-cyan">w/h</span></div>
                    <div class="text-center font-bold text-lg mt-2" v-else><iconEnergy width="18" height="18" iconColor="#333"/> {{totalCurrentSelected}} <span class="text-cyan">w/h</span></div>
                    <div class="text-sm text-center mb-2">{{$t('Labels.CurrentConsumption')}}</div>
                    <div class="text-center font-bold text-lg " v-if="!selectMarkers"><iconEnergy width="18" height="18" iconColor="#333" :active="true"/> {{totalAccumulated}} <span class="text-cyan">w/h</span></div>
                    <div class="text-center font-bold text-lg " v-else><iconEnergy width="18" height="18" iconColor="#333" :active="true"/> {{totalAccumulatedSelected}} <span class="text-cyan">w/h</span></div>
                    <div class="text-sm text-center mb-2">{{$t('Labels.AccumulatedConsumption')}}</div>
                  </div>
                </l-control>
                <l-control position="verticalcenterright" class="leaflet-topcenter">
                    <div class="container-tags my-2">
                      <div class="bg-primary rounded-sm text-white w-auto p-1 m-1 inline-block " v-for="(item) in markersSelected" v-bind:key="item.uuid">
                        {{item.name}} 
                        <feather-icon @click="deleteSelected(item)" icon="XIcon" svgClasses="h-5 w-5 mx-2" class="float-right cursor-pointer hover:text-grey"/>
                      </div>
                    </div>
                </l-control>
                <l-control-layers
                  :position="layersPosition"
                  :collapsed="true"
                  :sort-layers="true"
                />
                <l-control :position="layersPosition">
                  <div class="block text-right">
                    <vs-button @click="showFiltrar = !showFiltrar" class="text-grey-dark border-2 border-solid border-grey py-2 px-3" color="white" type="filled"><iconBase iconName="filter_list" :width="24" :height="24" iconColor="#b8c2cc"><iconFilter/></iconBase></vs-button>
                  </div>
                  <div v-if="showFiltrar" class="bg-white border-2 border-solid border-grey py-2 px-4 rounded-lg mt-1">
                    <div class="font-bold mb-2 text-center">{{$t('Labels.Filter') + ' ' +$t('Labels.By')}}:</div>
                    <div class="vx-row mb-3">
                      <vs-checkbox :disabled="getAll" v-model="filterRange" class="ml-4"><span class="font-bold"><span class="capitalize">{{$t('Labels.By')}}</span>{{' ' +$t('Labels.Range')}}</span></vs-checkbox>
                    </div>
                    <div class="vx-row mb-3">
                      <div class="vx-col w-1/2">
                        <label class="font-bold">{{$t('Labels.From')}}</label>
                        <datepicker :value="filters.begin_date" format="dd-MM-yyyy" :disabled="!filterRange" @selected="updateStartDate" :disabled-dates="disabledDates"></datepicker>
                        <div v-if="!datesValid" class="text-xs text-danger">{{$t('Messages.DatesRange')}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <label class="font-bold">{{$t('Labels.To')}}</label>
                        <datepicker :value="filters.end_date" format="dd-MM-yyyy" :disabled="!filterRange" @selected="updateEndDate" :disabled-dates="disabledDates"></datepicker>
                      </div>
                    </div>
                    <div class="vx-row mb-3">
                      <div class="vx-col w-1/2">
                        <label class="font-bold">{{$t('Labels.Serie')}}</label>
                        <vs-input class="w-full" :disabled="getAll" v-model="filters.serie" />
                      </div>
                      <div class="vx-col w-1/2">
                        <ul>
                          <li>
                            <vs-radio :disabled="getAll" v-model="filters.status" vs-name="radios1" vs-value="1" color="success">{{$t('Labels.On')}}</vs-radio>
                          </li>
                          <li>
                          <vs-radio :disabled="getAll" v-model="filters.status" vs-name="radios1" vs-value="0" color="danger">{{$t('Labels.Off')}}</vs-radio>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="vx-row mb-3">
                      <div class="vx-col w-1/2">
                        <label  class="font-bold">{{$t('Labels.CurrentConsumption')}}</label>
                        <vs-slider :disabled="getAll" v-model="filters.consumptionCurrent" text-fixed="%"  :min="0" :max="100"/>
                      </div>
                      <div class="vx-col w-1/2">
                        <label  class="font-bold">{{$t('Labels.AccumulatedConsumption')}}</label>
                        <vs-slider :disabled="getAll" v-model="filters.consumptionAccumulated" text-fixed="%"  :min="0" :max="100"/>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-1/4 "><vs-checkbox v-model="getAll" class="ml-4"><span class="font-bold capitalize">{{$t('Labels.All')}}</span></vs-checkbox></div>
                      <div class="vx-col w-3/4 text-right">
                        <vs-button :disabled="!datesValid" @click="getMapa()" color="primary" class="">{{$t('Labels.Filter')}}</vs-button>
                        <vs-button  @click="resetFilters()" color="danger" type="border" class="bg-white ml-2">{{$t('Labels.Clean')}}</vs-button>
                      </div>
                    </div>
                  </div>
                  <div class="block mt-3 text-right">
                    <vs-button @click="showCicuits = !showCicuits" class="text-grey-dark border-2 border-solid border-grey py-2 px-3" color="white" type="filled"><iconBase iconName="filter_list" :width="24" :height="24" iconColor="#b8c2cc"><iconCircuit/></iconBase></vs-button>
                  </div>
                  <div v-show="showCicuits" class="bg-white border-2 border-solid border-grey p-4 rounded-lg mt-1">
                    <div class="font-bold mb-2">{{$t('Labels.Show')+' '+$t('Labels.Circuit')+'s'}}</div>
                    <div class="container-alerts-control">
                      <vs-checkbox color="#000000" v-model="allSelected"  :style="'border: 2px solid #000 !important'" class="p-1  rounded-lg"><span class="uppercase font-bold">{{$t('Labels.All')}}</span></vs-checkbox>
                      <vs-checkbox v-bind:key="item.uuid" v-for="(item) in circuits" :style="'border: 2px solid ' + item.color + ' !important'" class="p-1 rounded-lg" :color="item.color" v-model="circuitsSelected" :vs-value="item.uuid"><span class="font-bold">{{item.name}}</span></vs-checkbox>
                    </div>
                  </div>
                </l-control>
                <l-tile-layer
                    v-for="tileProvider in tileProviders"
                    :key="tileProvider.name"
                    :name="tileProvider.name"
                    :visible="tileProvider.visible"
                    :url="tileProvider.url"
                    layer-type="base"
                />

                <!--<v-marker-cluster>-->
                  <l-marker
                    v-for="marker in markers"
                    :key="marker.alias"
                    :visible="marker.visible"
                    :draggable="marker.draggable"
                    :lat-lng.sync="marker.position"
                    @click="clickMarker(marker)"
                  >
                    <l-icon :icon-anchor="staticAnchor" class-name="someExtraClass">
                      <iconMarkerSelected  v-if="markersSelected.find(element => element.uuid == marker.uuid)" width="30" height="30" :iconColor="marker.circuit != null ? marker.circuit.color:'#000000'" />
                      <iconMarker  v-else width="25" height="25" :iconColor="marker.circuit != null ? marker.circuit.color:'#000000'" />
                    </l-icon>

                    <l-popup>
                      <div>
                        <div class="text-center my-2">
                          <iconLight width="50" height="50" iconColor="#ffbd59" :level="marker.intensity" />
                          <div class="text-xs font-bold">{{marker.intensity}}%</div>
                        </div>
                        <div class="text-center font-bold text-lg my-2">{{marker.name}}</div>
                        <div class="font-bold text-md text-center my-2">
                          <div v-if="marker.circuit !== null" class="w-5 h-5 inline-block rounded-sm align-middle" :style="{ 'background-color': marker.circuit.color }"></div>
                          <div class="inline-block ml-2 align-middle">{{marker.circuit !== null ? marker.circuit.name : 'N/A'}}</div>
                        </div>
                        <!--<div class="text-sm text-center mb-2">{{$t('Labels.Circuit')}}</div>-->                        
                        <div class="w-1/2 inline-block">
                          <div class="text-center font-bold text-lg"><iconEnergy width="18" height="18" iconColor="#333"/> {{parseFloat(marker.current).toFixed(2)}} <span class="text-cyan">w/h</span></div>
                          <div class="text-xs text-center mb-2">{{$t('Labels.CurrentConsumption')}}</div>
                        </div>
                        <div class="w-1/2 inline-block">
                          <div class="text-center font-bold text-lg "><iconEnergy width="18" height="18" iconColor="#333" :active="true"/> {{parseFloat(marker.accumulated).toFixed(2)}} <span class="text-cyan">w/h</span></div>
                          <div class="text-xs text-center mb-2">{{$t('Labels.AccumulatedConsumption')}}</div>
                        </div>
                        <div class="px-8 py-2">
                          <v-select 
                            :options="circuits" 
                            :reduce="circuit => circuit.uuid" 
                            label="name" 
                            v-if="circuits.length > 0" 
                            v-model="marker.assign" 
                            :value="marker.circuit != undefined ? marker.circuit.uuid : 0"
                            v-on:input="requestPassword(marker)"
                          >
                            <template #option="{name, color}">
                              <div>
                                <div class="w-5 h-5 inline-block rounded-sm align-middle" :style="{ 'background-color': color }"></div>
                                <div class="inline-block ml-2 align-middle">{{name}}</div>
                              </div>
                            </template>
                          </v-select>
                          <div class="py-1 text-center">{{$t('Labels.AssignToCircuit')}}</div>
                        </div>
                        <div class="text-center mb-1">
                          <vs-button size="small" color="primary" type="border" :to="'luminarias/'+marker.uuid">{{$t('Labels.SeeMore')}}</vs-button>
                        </div>
                        <vx-tooltip :text="marker.updatedAt || $t('Labels.Inactive')" class="text-center">
                          <div class=" text-center text-xs mb-2">{{marker.updatedAt.length > 0 ? relativeTimeConvert(marker.updatedAt) : $t('Labels.Inactive')}}</div>
                        </vx-tooltip>
                      </div>
                    </l-popup>

                  </l-marker>
                <!--</v-marker-cluster>-->
            </l-map>
            <div class="text-xs my-1">{{$t('Messages.SelectArea')}}</div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {request} from '@/request.js'
import {
  LMap,
  LTileLayer,
  LMarker,
  LLayerGroup,
  LTooltip,
  LIcon,
  LPopup,
  LControl,
  LCircle,
  LControlLayers
} from 'vue2-leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/Vue2LeafletMarkercluster'
import vSelect from 'vue-select'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import 'leaflet/dist/leaflet.css'
import 'leaflet-area-select'
import Datepicker from 'vuejs-datepicker'
import iconBase from '@/components/icons/iconBase'
import iconFilter from '@/components/icons/iconFilter'
import {formatDate, empty} from '@/helpers.js'
import iconLight from '@/components/icons/iconLight'
import iconEnergy from '@/components/icons/iconEnergy'
import iconCircuit from '@/components/icons/iconCircuit'
import iconMarker from '@/components/icons/iconMarker'
import iconMarkerSelected from '@/components/icons/iconMarkerSelected'
import checkbox from '@/components/checkbox/checkbox'
import {globalPassActions} from '@/globalPass'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
/* global L:true */

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]


export default {
  name: 'mapa',
  components: {
    'v-select': vSelect,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LControl,
    LCircle,
    LPopup,
    LIcon,
    LControlLayers,
    LLayerGroup,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    Datepicker,
    iconBase,
    iconFilter,
    iconLight,
    iconEnergy,
    iconCircuit,
    iconMarker,
    checkbox,
    iconMarkerSelected,
    VueTimepicker
  },
  data () {
    return {
      latlngs: [],
      filters:{
        serie:'',
        consumptionCurrent: [0, 100],
        consumptionAccumulated: [0, 100],
        begin_date: new Date(),
        end_date: new Date(),
        status: null
      },
      tileProviders,
      layersPosition: 'topright',
      center: [],
      staticAnchor: [12, 27],
      customText: 'Gateway',
      imagePath: 'images/vendor/leaflet/dist/',
      response: [],
      markers: [],
      status_mapa: false,
      status_heat: false,
      filterRange: false,
      showFiltrar: false,
      haveFullScreen: false,
      showCicuits: false,
      circuits: [],
      allSelected: true,
      circuitsSelected: [],
      totalCurrent: 0,
      totalAccumulated: 0,
      disabledDates: {
        from: new Date()
      },
      getAll: true,
      maxActiveEnergy: 0,
      maxReactiveEnergy: 0,
      selectMarkers: false,
      markersSelected: [],
      totalCurrentSelected: 0.00,
      totalAccumulatedSelected: 0.00,
      assignCircuit: null,
      banDimming: false,
      slideLight: 0,
      controlLight: false,
      circuitToAssign: null,
      banAssignCircuit: false,
      showAssignCircuit: false,
      showControlDimming: false,
      showControlDimmingSchedule: false,
      banSchedule: false,
      schedules: [
        {
          startDimming: 0,
          endDimming: 0,
          startSchedule: '00:00',
          endSchedule: '00:00'
        }
      ]
    }
  },
  methods: {
    async getMapa () {
      this.$vs.loading()
      this.selectMarkers = false
      const filter = {}
      if (!this.allSelected) {
        if (this.maxActiveEnergy > 0) {
          filter.begin_energy = (this.filters.consumptionCurrent[0] * this.maxActiveEnergy) / 100
          filter.end_energy =  (this.filters.consumptionCurrent[1] * this.maxActiveEnergy) / 100
        }
        if (this.maxReactiveEnergy > 0) {
          filter.begin_reactive_energy = (this.filters.consumptionAccumulated[0] * this.maxReactiveEnergy) / 100
          filter.end_reactive_energy = (this.filters.consumptionAccumulated[1] * this.maxReactiveEnergy) / 100
        }
        filter.serie = this.filters.serie
        filter.state = this.filters.status

        if (this.filterRange) {
          filter.begin_date = formatDate(this.filters.begin_date)
          filter.end_date = formatDate(this.filters.end_date)
        }

        if (!this.allSelected) filter.luminary_circuit_uuid = this.circuitsSelected
      } 
      const params = {
        url: 'luminaires_devices/map',
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.maxActiveEnergy = response.data.data.max_active_energy
        this.maxReactiveEnergy = response.data.data.max_reactive_energy
        this.center = [19.25101358132845, -103.69481138016101]
        this.totalCurrent = parseFloat(response.data.data.total_active_energy).toFixed(2)
        this.totalAccumulated = parseFloat(response.data.data.total_reactive_energy).toFixed(2)
        const positions = []
        this.markers = []
        for (let i = 0; i < this.response.length; i++) {
          if (this.response[i].latlong !== '') {
            positions.push([this.response[i].latlong.split(',')[0], this.response[i].latlong.split(',')[1]])
            this.markers.push({
              position: { lat: this.response[i].latlong.split(',')[0], lng: this.response[i].latlong.split(',')[1] },
              updatedAt:  this.response[i].updatedAt,
              circuit: this.response[i].luminaires_circuit,
              current: this.response[i].active_energy,
              accumulated: this.response[i].reactive_energy,
              intensity: this.response[i].dimming !== null && this.response[i].dimming !== '' ? parseInt((this.response[i].dimming || 0) * 100 / 255) : null,
              status: this.response[i].state || 0,
              uuid: this.response[i].uuid,
              serie: this.response[i].serie,
              draggable: false,
              visible: true,
              assign: this.response[i].luminaires_circuit !== null ? this.response[i].luminaires_circuit.uuid : null,
              name: this.response[i].name
            })
          }
        }


        this.status_mapa = true
        this.$vs.loading.close()
        const app = this
        setTimeout(function () {
          const maps = app.$refs.mymap.mapObject
          if (!app.haveFullScreen) {
            maps.addControl(new L.Control.Fullscreen())
            app.haveFullScreen = true    
            maps.selectArea.enable()
            maps.on('areaselected', (e) => {
              app.selectMarkers = true
              app.markersSelected = app.markers.filter(item => {
                return e.bounds.contains(item.position)
              })
              app.totalCurrentSelected = 0
              app.totalAccumulatedSelected = 0
              app.markersSelected.forEach(item => {
                app.totalCurrentSelected += parseFloat(parseFloat(item.current).toFixed(2))
                app.totalAccumulatedSelected += parseFloat(parseFloat(item.accumulated).toFixed(2))
              })
            })        
          }
          maps.fitBounds(positions)
        }, 1000)
      }).catch(() => {
        this.center = [19.25101358132845, -103.69481138016101]
        this.markers = []
        this.status_mapa = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    resetFilters () {
      this.filters.serie = null
      this.filters.consumptionCurrent = [0, 100]
      this.filters.consumptionAccumulated = [0, 100]
      this.filters.begin_date = new Date()
      this.filters.end_date = new Date()
      this.filters.status = null
      this.filters.circuit = null
      this.showDate = false
    },
    filterCircuit (uuid) {
      this.resetFilters()
      this.filters.circuit = uuid
      this.markers = []
      this.getMapa()
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    updateStartDate (date) {
      this.filters.begin_date = date
    },
    updateEndDate (date) {
      this.filters.end_date = date
    },
    async getCircuits () {
      const params = {
        url: 'luminaires_circuits/list',
        method: 'GET'
      }
      await request(params).then(response => {
        this.circuits = response.data.data
        this.allSelected = true
        this.circuits.forEach(element => {
          this.circuitsSelected.push(element.uuid)
        })
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    clickMarker (item) {
      const found = this.markersSelected.find(element => element.uuid === item.uuid)
      if (this.selectMarkers && found === undefined) {
        this.markersSelected.push(item)
        this.totalCurrentSelected += parseFloat(parseFloat(item.current).toFixed(2))
        this.totalAccumulatedSelected += parseFloat(parseFloat(item.accumulated).toFixed(2))
      }
    },
    deleteSelected (item) {
      this.totalCurrentSelected = parseFloat(this.totalCurrentSelected - parseFloat(item.current)).toFixed(2)
      this.totalAccumulatedSelected = parseFloat(this.totalAccumulatedSelected - parseFloat(item.accumulated)).toFixed(2)
      const filter = this.markersSelected.filter(element => element.uuid !== item.uuid)
      this.markersSelected = filter
    },
    async doAssign () {
      if (this.assignCircuit.circuit === null || this.assignCircuit.assign !== this.assignCircuit.circuit.uuid) {
        const data = {
          url: `luminaires_circuits/${this.assignCircuit.assign}/assign_luminaires?type=change`,
          method: 'PUT',
          params: {
            uuids: this.assignCircuit.uuid
          }
        }
        await request(data).then(() => {
          const circuit = this.circuits.find(e => e.uuid === this.assignCircuit.assign)
          this.markers.forEach(item => {
            if (item.uuid === this.assignCircuit.uuid) {
              item.circuit = circuit 
            }
          })
          this.assignCircuit = null
        })
      }
    },
    async doAssignSelected () {
      this.banAssignCircuit = false
      this.selected = []
      this.markersSelected.forEach(element => {
        this.selected.push(element.uuid)
      })
      const data = {
        url: `luminaires_circuits/${this.circuitToAssign}/assign_luminaires?type=change`,
        method: 'PUT',
        params: {
          uuids: this.selected.join(',')
        }
      }
      await request(data).then(() => {
        const circuit = this.circuits.find(e => e.uuid === this.circuitToAssign)
        this.markers.forEach(element => {
          const found = this.markersSelected.find(item => item.uuid === element.uuid)
          if (found !== undefined) element.circuit = circuit
        })
      })
    },
    requestPassword (marker) {
      if (marker === 'assignSelected') this.banAssignCircuit = true
      else if (marker === 'dimming') this.banDimming = true
      else if (marker === 'schedule') this.banSchedule = true
      else this.assignCircuit = marker
      globalPassActions.show()
    },
    async updateDimming () {
      this.banDimming = false
      this.selected = []
      this.markersSelected.forEach(element => {
        this.selected.push(element.uuid)
      })

      const params = {
        url: 'luminaires_devices/update_masive',
        method: 'PUT',
        params: {
          type: 'G',
          uuids: this.selected.join(','),
          dimming_set: Math.ceil((this.slideLight * 255) / 100)
        }
      }
      await request(params).then(() => {
        this.markers.forEach(element => {
          const found = this.markersSelected.find(item => item.uuid === element.uuid)
          if (found !== undefined) element.intensity = this.slideLight
        })
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    addSchedule () {
      if (this.schedules.length < 9) this.schedules.push({
        startDimming: 0,
        endDimming: 0,
        startSchedule: '00:00 AM',
        endSchedule: '00:00 AM'
      })
    },
    deleteSchedule (index) {
      this.schedules.splice(index, 1)
    },
    async updateSchedule () {
      this.banSchedule = false
      this.selected = []
      this.markersSelected.forEach(element => {
        this.selected.push(element.uuid)
      })
      const data = []
      this.schedules.forEach(element => {
        const start = element.startSchedule.split(':')
        const minutesStart = (parseInt(start[0]) * 60) + parseInt(start[1])
        const end = element.endSchedule.split(':')
        const minutesEnd = (parseInt(end[0]) * 60) + parseInt(end[1])
        const schedule = []
        schedule.push({
          hour: minutesStart,
          dimming: element.startDimming
        })
        schedule.push({
          hour: minutesEnd,
          dimming: element.endDimming
        })
        data.push(schedule)
      })
      const params = {
        url: 'luminaires_devices/update_masive?type=C',
        method: 'PUT',
        params: {
          type: 'C',
          uuids: this.selected.join(','),
          dimming_set: JSON.stringify(data)
        }
      }
      await request(params).then(() => {
        this.markers.forEach(element => {
          const found = this.markersSelected.find(item => item.uuid === element.uuid)
          if (found !== undefined) element.intensity = null
        })
        this.showControlDimmingSchedule = false
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },

  created () {
    this.getMapa()
    this.getCircuits()
  },
  computed: {
    datesValid () {
      const begin = new Date(this.filters.begin_date)
      const end = new Date(this.filters.end_date)
      return ((begin <= end && this.filterRange) || this.filterRange === false)  
    },
    isVisiblePassword () {
      return globalPassActions.getStatus()
    }
  },
  watch: { 
    allSelected (newVal, old) {
      if (newVal === true && old === false) {
        this.circuitsSelected = []
        this.circuits.forEach(element => {
          this.circuitsSelected.push(element.uuid)
        })
      } else if (newVal === false && old === true && this.circuitsSelected.length !== (this.circuits.length - 1)) {
        this.circuitsSelected = []
      }
    },
    circuitsSelected (val) {
      if (val.length < this.circuits.length && val.length !== 0) {
        this.allSelected = false
        this.getMapa()
      } else if (val.length === this.circuits.length) {
        this.allSelected = true
        this.getMapa()
      } else if (val.length === 0) {
        this.markers = []
        this.selectMarkers = false
        this.totalCurrent = 0
        this.totalAccumulated = 0
      } 
    },
    selectMarkers (val) {
      if (!val) {
        this.markersSelected = []
        this.totalCurrentSelected = 0
        this.totalAccumulatedSelected = 0
      }
        
    },
    isVisiblePassword (visible) {
      if (visible === false) if (!empty(globalPassActions.get())) {
        if (this.banDimming) this.updateDimming()
        else if (this.banAssignCircuit) this.doAssignSelected()
        else if (this.banSchedule) this.updateSchedule()
        else this.doAssign() 
      } else if (!this.banDimming) this.markers.forEach(item => {
        if (item.uuid === this.assignCircuit.uuid) {
          if (item.circuit !== null) item.assign = item.circuit.uuid
          else item.assign = null
        }
      })

    },
    controlLight (newVal) {
      if (!newVal) this.slideLight = 0
      else if (this.slideLight === 0) this.slideLight = 100 
    },
    slideLight (newVal) {
      if (newVal > 0 && this.controlLight === false) this.controlLight = true
      else if (newVal === 0 && this.controlLight === true) this.controlLight = false
    }
  }
}
</script>
